export default class suppressionEntry {
    constructor() {
        return {
            scope: {
                suppression: "="
            },
            template: require("../../../../views/subscriber/show/suppression-entry.html"),
            controller: SuppressionEntryCtrl,
            controllerAs: 'suppressionCtrl'
        };
    }
}

class SuppressionEntryCtrl {
    constructor($scope, $filter) {
        this._scope = $scope;
        this._translator = $filter('translate');

        this.suppressionSourceMap = {
            user: {
                campaign: {
                    email: this._translator('SUBSCRIBER:SHOW:USER_UNSUBSCRIBED_CAMPAIGN'),
                    text_message: this._translator('SUBSCRIBER:SHOW:USER_UNSUBSCRIBED_CAMPAIGN_TEXT_MESSAGE')
                },
                transactional: {
                    email: this._translator('SUBSCRIBER:SHOW:USER_UNSUBSCRIBED_TRANSACTIONAL'),
                    text_message: this._translator('SUBSCRIBER:SHOW:USER_UNSUBSCRIBED_TRANSACTIONAL_TEXT_MESSAGE')
                }
            },
            spam: {
                campaign: this._translator('SUBSCRIBER:SHOW:USER_SPAM_CAMPAIGN'),
                transactional: this._translator('SUBSCRIBER:SHOW:USER_SPAM_TRANSACTIONAL')
            },
            bounce: this._translator('SUBSCRIBER:SHOW:BOUNCE'),
            admin: {
                campaign: {
                    email: this._translator('SUBSCRIBER:SHOW:ADMIN_UNSUBSCRIBED_CAMPAIGN'),
                    text_message: this._translator('SUBSCRIBER:SHOW:ADMIN_UNSUBSCRIBED_CAMPAIGN_TEXT_MESSAGE')
                },
                transactional: {
                    email: this._translator('SUBSCRIBER:SHOW:ADMIN_UNSUBSCRIBED_TRANSACTIONAL'),
                    text_message: this._translator('SUBSCRIBER:SHOW:ADMIN_UNSUBSCRIBED_TRANSACTIONAL_TEXT_MESSAGE')
                }
            },
            api: {
                campaign: {
                    email: this._translator('SUBSCRIBER:SHOW:API_UNSUBSCRIBED_CAMPAIGN'),
                    text_message: this._translator('SUBSCRIBER:SHOW:API_UNSUBSCRIBED_CAMPAIGN_TEXT_MESSAGE')
                },
                transactional: {
                    email: this._translator('SUBSCRIBER:SHOW:API_UNSUBSCRIBED_TRANSACTIONAL'),
                    text_message: this._translator('SUBSCRIBER:SHOW:API_UNSUBSCRIBED_TRANSACTIONAL_TEXT_MESSAGE')
                }
            },
            botstop: this._translator('SUBSCRIBER:SHOW:BOTSTOP'),
        };
    }

    getMessage() {
        if (this._scope.suppression.source.data.name == 'spam') {
            return this.suppressionSourceMap['spam'][this._scope.suppression.dispatcherType.data.name];
        }
        if (this._scope.suppression.source.data.name == 'bounce') {
            return this.suppressionSourceMap['bounce'];
        }
        if (this._scope.suppression.source.data.name == 'botstop') {
            return this.suppressionSourceMap['botstop'];
        }
        return this.suppressionSourceMap
            [this._scope.suppression.source.data.name]
            [this._scope.suppression.dispatcherType.data.name]
            [this._scope.suppression.messageType.data.name];
    };
};
